import { Flex, Layout } from "antd";
import { styled } from "styled-components";


export const FormWrap = styled.div`
    & .textInput{
        .ant-input-suffix{
            display: none;
        }
    }
    & .ant-picker-disabled{
        .ant-picker-input{
            #itemOrderTime{
                color: black;
            }
        }
        
        .ant-picker-suffix{
            display: none;
        }
    }
  
`

